import type { FormEvent } from 'react'

export const preventNumericInput = (event: FormEvent<HTMLInputElement>) => {
  const target = event.currentTarget
  const sanitized = target.value.replace(/\d+/g, '')

  if (sanitized !== target.value) {
    target.value = sanitized
  }
}
